{
  "name": "angular-client-base",
  "version": "2.2.10+57",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start-with-browser": "ng serve -o --port 4305",
    "startdebug": "ng serve",
    "startlocal": "ng serve -c testlocal",
    "buildcheck": "ng build -c buildCheck",
    "build": "ng build",
    "buildprod": "ng build -c production",
    "builddev": "ng build -c dev",
    "buildtest": "ng build -c test",
    "buildtesthelp": "ng build -c testhelp",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.0.6",
    "@angular/cdk": "^20.0.5",
    "@angular/common": "^20.0.6",
    "@angular/compiler": "^20.0.6",
    "@angular/core": "^20.0.6",
    "@angular/forms": "^20.0.6",
    "@angular/localize": "^20.0.6",
    "@angular/platform-browser": "^20.0.6",
    "@angular/platform-browser-dynamic": "^20.0.6",
    "@angular/router": "^20.0.6",
    "@fortawesome/angular-fontawesome": "^2.0.1",
    "@fortawesome/fontawesome-svg-core": "^6.7.2",
    "@fortawesome/free-solid-svg-icons": "^6.7.2",
    "@mapbox/mapbox-gl-draw": "^1.5.0",
    "@mapbox/mapbox-gl-draw-static-mode": "^1.0.1",
    "@mapbox/mapbox-gl-geocoder": "^5.0.3",
    "@mapbox/search-js-core": "^1.3.0",
    "@ng-idle/core": "^16.0.0",
    "@ng-idle/keepalive": "^16.0.0",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@syncfusion/ej2-angular-base": "30.1.37",
    "@syncfusion/ej2-angular-buttons": "30.1.37",
    "@syncfusion/ej2-angular-calendars": "30.1.37",
    "@syncfusion/ej2-angular-dropdowns": "30.1.37",
    "@syncfusion/ej2-angular-grids": "30.1.38",
    "@syncfusion/ej2-angular-inputs": "30.1.38",
    "@syncfusion/ej2-angular-layouts": "30.1.37",
    "@syncfusion/ej2-angular-navigations": "30.1.37",
    "@syncfusion/ej2-angular-notifications": "30.1.37",
    "@syncfusion/ej2-angular-popups": "30.1.37",
    "@syncfusion/ej2-angular-progressbar": "30.1.37",
    "@syncfusion/ej2-angular-splitbuttons": "30.1.37",
    "@syncfusion/ej2-base": "30.1.38",
    "@syncfusion/ej2-locale": "30.1.37",
    "@zxing/browser": "^0.1.5",
    "@zxing/library": "^0.21.3",
    "@zxing/ngx-scanner": "20.0.0",
    "angularx-qrcode": "^20.0.0",
    "bootstrap": "^5.3.7",
    "cldr-data": "^36.0.4",
    "core-js": "^3.43.0",
    "luxon": "^3.6.1",
    "mapbox-gl": "^3.13.0",
    "ngx-lightbox": "^3.0.0",
    "rxjs": "^7.8.2",
    "sass": "^1.89.2",
    "tslib": "^2.8.1",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.0.5",
    "@angular-eslint/builder": "^20.1.1",
    "@angular-eslint/eslint-plugin": "^20.1.1",
    "@angular-eslint/eslint-plugin-template": "^20.1.1",
    "@angular-eslint/schematics": "^20.1.1",
    "@angular-eslint/template-parser": "^20.1.1",
    "@angular/cli": "^20.0.5",
    "@angular/compiler-cli": "^20.0.6",
    "@angular/language-service": "^20.0.6",
    "@types/jasmine": "^5.1.8",
    "@types/jasminewd2": "^2.0.13",
    "@types/luxon": "^3.6.2",
    "@types/mapbox__mapbox-gl-draw": "^1.4.9",
    "@types/mapbox-gl": "^3.4.1",
    "@types/node": "^24.0.10",
    "@typescript-eslint/eslint-plugin": "^8.34.1",
    "@typescript-eslint/parser": "^8.34.1",
    "eslint": "^9.29.0",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jsdoc": "^51.3.4",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "jasmine-core": "^5.8.0",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "ts-node": "^10.9.2",
    "typescript": "5.8.3"
  }
}
